var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('detail-view',{attrs:{"endpoint":_vm.endpoint + 'organizations',"name":"Organization","parentRoute":"organizations","permissions":"organizations","values":_vm.values}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45ce0a13","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"objectAssign":"Object.assign","transforms":{"stripWith":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/OrganizationEdit.vue
// module id = null
// module chunks = 